export const removeExtraSpacesFromClassNames = (classNames: string) => {
  return classNames.replace(/\s+/g, " ").trim();
};
